// extracted by mini-css-extract-plugin
export default {"table":"_3Wzvm0Vpq0Wa5_LSs8QC55","td":"_3VfmXpTGWw6nD7ySZcVhcv","th":"VfxL6dbv0ojgRcAZ4XFgu"};